import { Input } from 'almanac-ui/TextInputField/Input'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './FromText.module.scss'
import { Heading } from 'almanac-ui/Heading/Heading'
import { useId } from '@react-aria/utils'

export type FromTextProps = {
  sampleText: string
  onChange: (sampleText: string) => void
}

export const FromWebsiteText: React.FC<React.PropsWithChildren<FromTextProps>> = ({ sampleText, onChange }) => {
  const { isMobile } = useResponsiveDesign()
  const id = useId()

  return (
    <div className={Styles.FromText}>
      <Heading level={4} id={id}>
        Try to copy and paste all the text from your website in the box below
      </Heading>
      <Input
        data-testid="voice-paste-in-text"
        value={sampleText}
        onChange={(e) => onChange(e.currentTarget.value)}
        size="xl"
        name="sampleText"
        isTextarea
        resizable={false}
        rows={isMobile ? 6 : 8}
        maxHeight={isMobile ? 120 : 184}
        id="source-website-text"
        placeholder="Paste text"
        autoFocus
        aria-labelledby={id}
      />
      <div className={Styles.charCounter}>{sampleText.length}/7000</div>
    </div>
  )
}
